import { UserTranslationOptions } from '@modules/store/user/types/UserTranslationOptions.entity';
import { Tenancy } from '@modules/husleie-framework/src/types/Tenancy.entity';
import DateTimeOperations from '@modules/husleie-framework/src/static-classes/DateTimeOperations.class';
import { Tenant } from '@modules/husleie-framework/src/types/Tenant.entity';
import TenantConversionOperations from '@modules/store/tenant/static-classes/TenantConversionOperations';

export default class TenancyConversionOperations {
  static apiToInternal(apiTenancy: any, options: UserTranslationOptions): Tenancy {
    const tenants: Tenant[] = apiTenancy.tenants
      ? apiTenancy.tenants.map((apiTenant: any) => {
          return TenantConversionOperations.apiToInternal(apiTenant, options);
        })
      : [];

    return {
      ...apiTenancy,
      startDate: DateTimeOperations.apiDateToInternalDate(apiTenancy.startDate),
      endDate: DateTimeOperations.apiDateToInternalDate(apiTenancy.endDate),
      tenants,
    };
  }

  static internalToApi(tenancy: Tenancy) {
    const tenants: any = tenancy.tenants.map((tenant: Tenant) => {
      return TenantConversionOperations.internalToApi(tenant);
    });
    return {
      ...tenancy,
      startDate: DateTimeOperations.internalToApiDate(tenancy.startDate),
      endDate: DateTimeOperations.internalToApiDate(tenancy.endDate),
      tenants,
    };
  }
}
